module.exports = __webpack_public_path__ + "img/5.866c6a5c.png";